<fu-simple-input
  class="select"
  [class.readonly]="isReadonly()"
  [class.focus]="dropdownRef.isDropdownOpened$ | async"
  [formControl]="control()"
  [iconTemplate]="arrowTmpl"
  #dropdownRef="fuDropdownTrigger"
  [fuDropdownTriggerFor]="dropdown"
  [placeholder]="placeholder()"
  [label]="label()"
  [isReadonly]="true"
  [hint]="hint()"
  [isHintVisible]="true"
  [required]="required()"
  [style.height.px]="height()"
  [showValidationMessage]="false"
  [offReadonlyStyle]="true"
  [offsetY]="height() + 4"
  [autoOverlayPosition]="true" />

<ng-template #arrowTmpl>
  <fu-icon
    class="arrow-icon"
    [class.active]="dropdownRef.isDropdownOpened$ | async"
    [class.hidden]="isReadonly()"
    iconName="fu-chevron-right"
    size="20" />
</ng-template>

@if (selectedValue) {
  <div class="selected-item">
    <ng-container
      *ngTemplateOutlet="
        itemTpl() || defaultItemTpl;
        context: { $implicit: selectedValue }
      " />
  </div>
}

<fu-dropdown #dropdown>
  <div class="dropdown">
    @if (withSearch()) {
      <div class="search">
        <input
          class="search-control"
          type="text"
          [placeholder]="'searchSelect.placeholder' | translate"
          [formControl]="searchControl"
          (click)="$event.stopPropagation()" />

        <fu-icon class="search-icon" iconName="search" size="16" />
      </div>
    }

    @if (filteredItems()?.length) {
      <div class="select-items" [class.select-items-tmpl]="itemTpl()">
        @for (item of filteredItems(); track item[valueField()]) {
          <div
            class="select-item"
            [class.selected]="isSelected(item)"
            [attr.data-testid]="'item' + $index"
            (click)="toggleItem(item, $event)">
            @if (multi()) {
              <fu-icon
                class="checkbox"
                size="16"
                [iconName]="
                  isSelected(item) ? 'fu-ms-checkbox-active' : 'fu-ms-checkbox'
                " />
            }
            <ng-container
              *ngTemplateOutlet="
                itemTpl() || defaultItemTpl;
                context: { $implicit: item }
              " />
          </div>
        }
      </div>
    }
  </div>
</fu-dropdown>

<ng-template #defaultItemTpl let-item>
  <div class="select-item-default">
    @if (item.icon) {
      <kr-provider-icon [providerType]="item.icon" />
    }

    {{ item[nameField()] || item }}
  </div>
</ng-template>
